module.exports = __webpack_public_path__ + "img/gzh.d4278d10.png";